import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatChipOption, MatChipListbox, MatChipSelectionChange } from '@angular/material/chips';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CognitoUser } from 'app/core/auth-shim';
import { filter, find } from 'lodash-es'
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataShareService } from '../../../services/data-share.service';
import { getDaysOver, isPastPaymentGrace } from 'app/shared/billing/payment-grace';
import { AccountMembership, AccountType, APIService, UpdateAccountMembershipAction, UpdateAccountMembershipInput, UpdateUserInput, User, UserStatus } from '../../API.service.custom';
import { AuthService } from '../auth.service';
import localforage from 'localforage';
import { DialogService } from 'app/shared/dialog';
import { TeamInboxComponent } from 'app/shared/conversation/team-inbox/team-inbox.component';
import _ from 'lodash-es';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/list';
import { TitleCasePipe } from '@angular/common';


@Component({
    selector: 'app-payment-pending',
    templateUrl: './payment-pending.component.html',
    styleUrls: ['./payment-pending.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatButton, MatIcon, MatTooltip, MatDivider, RouterLink, MatChipListbox, MatChipOption, TitleCasePipe]
})
export class PaymentPendingComponent implements OnInit, OnDestroy {
  showDashboardOption = false;
  daysRemaining: number = null
  private userId = null;
  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();
  isLoading = true

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  private activeAccountMemberships: AccountMembership[] = [];
  private registeredUser: User = null;

  membershipId = null;
  activeAccount: AccountMembership = null;
  availableMemberships: AccountMembership[] = [];

  accountMembershipUpdateInitiated: Boolean = false;
  accountsInNeedOfAcceptance: AccountMembership[] = [];

  bankAccount = { bankName: "ICICI Bank", accountNumber: "004705500853", ifsc: "ICIC0000047", accountHolderName: "Evdusk Datatech Private Limited", typeOfAccount: "Current" }
  private routeParamSubscription?: Subscription;


  constructor(
    private dataService: DataShareService,
    private api: APIService,
    private toastr: ToastrService,
    private titleService: Title,
    private logger: NGXLogger,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private clipboard: Clipboard,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trial');
    this.routeParamSubscription = this.route.paramMap.subscribe(params => {
      this.membershipId = params.get('id');
      this.getUserDetailsAndId();
    });

  }

  ngOnDestroy(): void {
    this.routeParamSubscription?.unsubscribe();
  }

  public async getUserDetailsAndId() {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      if (this.userId) {
        this.getUserRegistrationDetail(this.userId);
      }
      this.userDetails_.next(userDetails);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }

  private getUserRegistrationDetail(userId: string) {
    this.api.GetUser(userId).then(async event => {
      this.logger.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.registeredUser = event;
        this.dataService.setRegisteredUser(this.registeredUser)
        this.getuserAccountMemberships(event);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user registration detail', e);
      });

  }

  private getuserAccountMemberships(user: User) {
    this.api.AccountsByUser(user.id).then(event => {
      this.logger.log('User Account Memberships Fetched : ', event);
      if (event && event.items && event.items.length > 0) {
        event.items.forEach(item => {
          item.user = user;
        });
        this.activeAccountMemberships = filter(event.items, function (o) {
          return (o.userAccountStatus == UserStatus.ACTIVE || o.userAccountStatus == UserStatus.APPROVED) && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
        });
        this.accountsInNeedOfAcceptance = filter(event.items, function (item) {
          return item.userAccountStatus == UserStatus.APPROVED;
        });
        console.log("activeAccountMemberships memberships are ", this.activeAccountMemberships);
        if (this.activeAccountMemberships.length > 0) {
          if (this.membershipId != null && this.membershipId != "") {
            this.activeAccount = find(this.activeAccountMemberships, { 'id': this.membershipId });
            console.log("Active account membership is ", this.activeAccount);
            this.dataService.setActiveAccount(_.cloneDeep(this.activeAccount));
            if (this.activeAccount && this.activeAccount.account && this.activeAccount.account.paidForTillDate) {
              if (isPastPaymentGrace(this.activeAccount.account.paidForTillDate)) {
                var membershipAccountId = this.activeAccount.accountId;
                this.availableMemberships = filter(this.activeAccountMemberships, function (o) {
                  return o.account.id != membershipAccountId && (!o.account.trialAccountEndDate || o.account.trialAccountEndDate > (new Date()).toISOString())
                    && (!o.account.paidForTillDate || o.account.paidForTillDate > (new Date()).toISOString());
                });
                console.log("Available memberships are ", this.availableMemberships);
              }
            }
            else {
              this.updateLastActiveAccountWeb();
            }
          }
          else
            this.activeAccount = this.activeAccountMemberships[0];
        }
        this.isLoading = false;
        this.getTrialDaysRemaining();
      }
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
        this.isLoading = false;
      });
  }

  payNow(){
    if(this.activeAccount?.account?.lastPaymentData?.paymentLinkUrl){
      window.open(this.activeAccount?.account?.lastPaymentData?.paymentLinkUrl, "_blank");
    }
  }

  copyPaymentLink(){
    if(this.activeAccount?.account?.lastPaymentData?.paymentLinkUrl){
      this.clipboard.copy(this.activeAccount?.account?.lastPaymentData?.paymentLinkUrl);
      this.toastr.success("Link Copied!!!")
    }
  }

  openSupportChat() {
    let channeId = `${this.activeAccount.accountId}__SALESMAX_SUPPORT_ALL`;
    let ref = this.dialogService.open(TeamInboxComponent, {
      data: { selectedChannelId: channeId, viewMode: 'dialog-mode' }
    }, 1);
  }


  getTrialDaysRemaining() {
    this.showDashboardOption = false;
    if (this.activeAccount.account.accountType == AccountType.TEAM && this.activeAccount.account.lastPaymentDataId != null && (this.activeAccount.account.paidForTillDate != null || this.activeAccount.account.paidUpTo != null)) {
      if(!this.activeAccount.account.paidForTillDate){
        this.showDashboardOption = true;
      }
      else{
        const now = new Date();
        this.daysRemaining = getDaysOver(this.activeAccount.account.paidForTillDate, now);
        if (!isPastPaymentGrace(this.activeAccount.account.paidForTillDate, now)){
          this.showDashboardOption = true;
        }
        else{
          this.showDashboardOption = false;
        }
        this.isLoading = false;
    }}
    else{
        this.router.navigate(['/home/dashboard']);
    }
  }

  backToDashboard(){
    this.router.navigate(['/home/dashboard']);
  }

  toggleSelection(change: MatChipSelectionChange) {
    if (!change.isUserInput) {
      return;
    }

      const chip = change.source;

    if (change.selected) {
      this.activeAccount = change.source.value;
      this.updateLastActiveAccountWeb();
    }
  }


  updateLastActiveAccountWeb() {
    localforage.setItem('lastActiveAccountSelectedInBrowser', this.activeAccount.accountId);
    let input = <UpdateUserInput>{};
    input.lastSelectedAccountWeb = this.activeAccount.accountId;
    input.id = this.userId;
    this.api.UpdateUser(input).then(event => {
      this.logger.log('Last Active Account Web Updated : ', event);
      this.dataService.setActiveAccount(null);
      this.router.navigate(['/']);
    })
      .catch(e => {
        this.logger.log('error updating last active account for user', e);
      });
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        this.logger.log(e.errors[_i].message);
      }
    }
  }

}

